
import {createContext} from 'react'

export const LangContext = createContext();  
export const MobileContext = createContext(); 
export const MenuContext = createContext();  
export const ReferenceContext = createContext(); 